module.exports = __webpack_public_path__ + "static/media/right-image.6077d773.png";